module.exports = new Promise((resolve) => {
                    const src = 'https://kin-analytics-cp.web.app/remoteEntry.js';
                    const el = document.createElement('script');
                    el.src = src;
                    el.onload = () => resolve(window.CpAppMicro);
                    el.onerror = () => { console.warn('[MFE] CpAppMicro failed to load'); resolve({ get: () => Promise.resolve(() => () => null), init: () => {} }); };
                    document.head.appendChild(el);
                });